import * as yup from 'yup';

export const getOperatingCostInvoiceLineSchema = (t: (key: string) => string) =>
  yup.object({
    areaDesignation: yup.string().required(t('errors.required')),
    nameOnStatement: yup.string().required(t('errors.required')),
    sfmPositionId: yup.string().required(t('errors.required')),
    status: yup.string().required(t('errors.required')),
    isFlatRate: yup.boolean().required(t('errors.required')),
    totalAmount: yup.number().optional().nullable(),
    customerAmount: yup.number().optional().nullable(),
    totalArea: yup.number().optional().nullable(),
    customerArea: yup.number().optional().nullable(),
  });
